const defaultTheme = {
  '--font-primary': "'CarlsbergSans', sans-serif",
  '--font-secondary': "'Montserrat', sans-serif",
  '--text-primary': '#1C2025',
  '--buttons-primary': '#1C2025',
  '--text-secondary': '#1C2025',
  '--icons-color': '#000000',
  '--sidenav-color': '#8ba0b9',
  '--footer-background': '#f1f4f8',
  '--footer-color': '#7A808A',
  '--footer-logo-color': '#7A808A',
  '--nav-color': '#8ba0b9',
  '--nav-font-size': '14px'
};

const greekTheme = {
  '--font-primary': "'Ubuntu', sans-serif",
  '--font-secondary': "'Ubuntu', sans-serif",
  '--text-primary': '#1C2025',
  '--buttons-primary': '#1C2025',
  '--text-secondary': '#1C2025',
  '--icons-color': '#000000',
  '--sidenav-color': '#8ba0b9',
  '--footer-background': '#f1f4f8',
  '--footer-color': '#7A808A',
  '--footer-logo-color': '#7A808A',
  '--nav-color': '#8ba0b9',
  '--nav-font-size': '14px'
};

const uyghurTheme = {
  '--font-primary': "'Alkatip', sans-serif",
  '--font-secondary': "'Alkatip', sans-serif",
  '--text-primary': '#1C2025',
  '--buttons-primary': '#1C2025',
  '--text-secondary': '#1C2025',
  '--icons-color': '#000000',
  '--sidenav-color': '#8ba0b9',
  '--footer-background': '#f1f4f8',
  '--footer-color': '#7A808A',
  '--footer-logo-color': '#7A808A',
  '--nav-color': '#8ba0b9',
  '--nav-font-size': '14px'
};

const getTheme = (lang: string) => {
  if (lang === 'ug') {
    return uyghurTheme;
  }

  if (lang === 'el') {
    return greekTheme;
  }

  return defaultTheme;
};

export default getTheme;
